'use client';

import { type FC } from 'react';
import { Button, ButtonGroup, Flex } from '@/_components';
import styles from './SelectAllRows.module.css';
import { SelectAllRowsProps } from './SelectAllRows.types';

export const SelectAllRows: FC<SelectAllRowsProps> = ({
  children,
  isLoading,
  onClearRowSelection,
  onSelectAll,
  selectedCount,
  totalCount,
}) => {
  const isAllSelected: boolean = totalCount === selectedCount;

  if (selectedCount <= 0) return null;

  return (
    <Flex className={styles.selectAllRows} isBetween={true}>
      <Flex isYCentered={true} gap={10}>
        <ButtonGroup>
          <Button
            intent="primary"
            isDisabled={isLoading || isAllSelected}
            size="small"
            iconLeft="plus"
            onClick={onSelectAll}
            count={totalCount}
            value="Select all"
          />
          <Button
            intent="secondary"
            isDisabled={isLoading}
            size="small"
            count={selectedCount}
            onClick={onClearRowSelection}
            value="Clear selection"
          />
        </ButtonGroup>
      </Flex>

      <ButtonGroup>{children}</ButtonGroup>
    </Flex>
  );
};
